import { addSpaceMemberGQLMutation, getMemberSpacesGQLQuery, getSpaceMembersGQLQuery, removeSpaceMembersGQLMutation, } from '../../graphql/index.js';
export class SpaceMembersClient {
    constructor(client) {
        this.client = client;
    }
    async add(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: addSpaceMemberGQLMutation(fields),
            variables,
            customToken: accessToken,
        });
        return result.addSpaceMembers;
    }
    async listMembers(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: getSpaceMembersGQLQuery(fields),
            variables,
            customToken: accessToken,
        });
        return result.spaceMembers;
    }
    async listSpaces(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: getMemberSpacesGQLQuery(fields),
            variables,
            customToken: accessToken,
        });
        return result.memberSpaces;
    }
    async remove(variables, accessToken) {
        const result = await this.client.authorizedRequest({
            query: removeSpaceMembersGQLMutation(),
            variables,
            customToken: accessToken,
        });
        return result.removeSpaceMembers;
    }
}
//# sourceMappingURL=spaceMembers.client.js.map